import React, { ReactElement } from 'react';
import { NavigateFunction } from 'react-router-dom';
import { CellContext, ColumnDef } from '@tanstack/react-table';

import { AdaptiveTableCell } from '@components/common';
import Actions from '@components/common/Actions';
import TextAvatar from '@components/common/TextAvatar';

import { formatDate } from '@utils/date';

import { routes } from '@constants/routes';

import styles from '../AssetRentRequests/AssetRentRequests.module.scss';

const {
	adminPanel: {
		index,
		incomingRequestsPath,
	},
} = routes;

const getIncomingRequestsColumns = (navigate: NavigateFunction): ColumnDef<any>[] => {
	const handleView = (id?: string) => () => {
		if (!id) return;

		navigate(`${index}${incomingRequestsPath}/${id}`);
	};

	return [
		{
			header: 'Request ID',
			accessorKey: 'requestId',
			enableSorting: false,
			cell: ({ getValue, row }: CellContext<any, any>): ReactElement => {
				const value = getValue();

				return (
					<AdaptiveTableCell
						onDoubleClick={handleView(row.original.id)}
						text={value}
					/>
				);
			},
		},
		{
			header: 'Organisation',
			accessorKey: 'organisation',
			enableSorting: false,
			cell: ({ row }: CellContext<any, any>): ReactElement => {
				return (
					<div
						className={styles.assetOwnerName}
						onDoubleClick={handleView(row.original.id)}
					>
						<TextAvatar
							avatarId={row.original?.networkOperator?.avatar?.id}
							fontSize='10px'
							fontWeight={400}
							fullName={row?.original?.networkOperator?.name}
							id={row?.original?.networkOperator?.id}
							isProfileLogo
							size='30px'
						/>
						<AdaptiveTableCell text={row?.original?.networkOperator?.name} />
					</div>
				);
			},
		},
		{
			header: 'Asset quantity',
			accessorKey: 'assetQuantity',
			enableSorting: false,
			cell: ({ getValue, row }: CellContext<any, any>): ReactElement => {
				const value = getValue();

				return (
					<AdaptiveTableCell
						onDoubleClick={handleView(row.original.id)}
						text={value}
					/>
				);
			},
		},
		{
			header: 'Request date',
			accessorKey: 'createdAt',
			cell: ({ getValue, row }: CellContext<any, any>): ReactElement => {
				const value = getValue();

				return (
					<AdaptiveTableCell
						onDoubleClick={handleView(row.original.id)}
						text={formatDate(value, 'dd/MM/yy')}
					/>
				);
			},
		},
		{
			header: 'Request Status',
			accessorKey: 'requestStatus',
			cell: ({ getValue, row }: CellContext<any, any>): ReactElement => {
				const value = getValue();

				return (
					<AdaptiveTableCell
						onDoubleClick={handleView(row.original.id)}
						text={value?.title}
					/>
				);
			},
		},
		{
			header: () => <div className={styles.actionsHeaderColumn}><span>Actions</span></div>,
			accessorKey: 'actions',
			enableSorting: false,
			cell: ({ row }: CellContext<any, any>): ReactElement => {
				return (
					<Actions
						gridNumberOfColumns={1}
						isView
						viewHandler={handleView(row.original.id)}
						viewTooltip='View request card'
					/>
				);
			},
		},
	];
};

export default getIncomingRequestsColumns;
